const SITE_URL = 'https://www.one-hour.fr'

export const ENTITY_IDS = {
  organization: `${SITE_URL}/#organization`,
  website: `${SITE_URL}/#website`,
  charonne: `${SITE_URL}/#location-charonne`,
  voltaire: `${SITE_URL}/#location-voltaire`
}

const organization = {
  '@type': 'Organization',
  '@id': ENTITY_IDS.organization,
  name: 'One Hour Escape Game',
  legalName: 'IKONE WEB',
  url: `${SITE_URL}/`,
  logo: {
    '@type': 'ImageObject',
    '@id': `${SITE_URL}/#logo`,
    url: `${SITE_URL}/presse-media/onehour-logo2.jpg`,
    contentUrl: `${SITE_URL}/presse-media/onehour-logo2.jpg`,
    width: 720,
    height: 720
  },
  description: "One Hour propose cinq expériences d'escape game immersives dans deux établissements du 11e arrondissement de Paris.",
  sameAs: [
    'https://www.facebook.com/onehourliveescapegame/',
    'https://www.instagram.com/onehour_escape/',
    'https://www.tiktok.com/@onehour_escapegame'
  ]
}

const openingHoursSpecification = {
  '@type': 'OpeningHoursSpecification',
  dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  opens: '10:00',
  closes: '00:00'
}

const locations = {
  charonne: {
    '@type': 'LocalBusiness',
    '@id': ENTITY_IDS.charonne,
    name: 'One Hour Charonne',
    url: `${SITE_URL}/contact/`,
    telephone: '+33972545043',
    parentOrganization: { '@id': ENTITY_IDS.organization },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '24 rue Emile Lepeu',
      postalCode: '75011',
      addressLocality: 'Paris',
      addressCountry: 'FR'
    },
    openingHoursSpecification
  },
  voltaire: {
    '@type': 'LocalBusiness',
    '@id': ENTITY_IDS.voltaire,
    name: 'One Hour Voltaire',
    url: `${SITE_URL}/contact/`,
    telephone: '+33972545043',
    parentOrganization: { '@id': ENTITY_IDS.organization },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '23 rue Servan',
      postalCode: '75011',
      addressLocality: 'Paris',
      addressCountry: 'FR'
    },
    openingHoursSpecification
  }
}

export const rooms = {
  lostAsylum: {
    '@type': 'TouristAttraction', '@id': `${SITE_URL}/lost-asylum/#room`, name: 'Lost Asylum',
    url: `${SITE_URL}/lost-asylum/`,
    description: "Escape game d'épouvante immersif dans un hôpital psychiatrique abandonné, pour 2 à 5 joueurs.",
    image: `${SITE_URL}/static/media/pressen-5.jpg`, containedInPlace: { '@id': ENTITY_IDS.charonne }
  },
  veryBadNight: {
    '@type': 'TouristAttraction', '@id': `${SITE_URL}/very-bad-night/#room`, name: 'Very Bad Night',
    url: `${SITE_URL}/very-bad-night/`,
    description: 'Escape game humoristique et décalé autour d’un lendemain de soirée, pour 2 à 6 joueurs.',
    image: `${SITE_URL}/static/media/pressen-3.jpg`, containedInPlace: { '@id': ENTITY_IDS.charonne }
  },
  abattoir: {
    '@type': 'TouristAttraction', '@id': `${SITE_URL}/abattoir/#room`, name: "L'Abattoir",
    url: `${SITE_URL}/abattoir/`,
    description: "Escape game d'horreur immersif inspiré des slashers, pour 2 à 5 joueurs.",
    image: `${SITE_URL}/static/media/OHpresse27.jpg`, containedInPlace: { '@id': ENTITY_IDS.voltaire }
  },
  yakuza: {
    '@type': 'TouristAttraction', '@id': `${SITE_URL}/yakuza/#room`, name: 'Mission Yakuza',
    url: `${SITE_URL}/yakuza/`,
    description: "Escape game d'enquête policière inspiré de l'univers des Yakuza, pour 2 à 6 joueurs.",
    image: `${SITE_URL}/static/media/pressen-2.jpg`, containedInPlace: { '@id': ENTITY_IDS.voltaire }
  },
  expeditionMaudite: {
    '@type': 'TouristAttraction', '@id': `${SITE_URL}/expedition-maudite/#room`, name: "L'Expédition Maudite",
    url: `${SITE_URL}/expedition-maudite/`,
    description: "Escape game d'aventure et d'exploration dans un tombeau oublié, pour 2 à 6 joueurs.",
    image: `${SITE_URL}/static/media/OHpresse30.jpg`, containedInPlace: { '@id': ENTITY_IDS.voltaire }
  }
}

locations.charonne.containsPlace = [{ '@id': rooms.lostAsylum['@id'] }, { '@id': rooms.veryBadNight['@id'] }]
locations.voltaire.containsPlace = [{ '@id': rooms.abattoir['@id'] }, { '@id': rooms.yakuza['@id'] }, { '@id': rooms.expeditionMaudite['@id'] }]

const website = {
  '@type': 'WebSite', '@id': ENTITY_IDS.website, url: `${SITE_URL}/`, name: 'One Hour Escape Game',
  publisher: { '@id': ENTITY_IDS.organization }, inLanguage: ['fr', 'en']
}

export const buildHomeStructuredData = () => ({
  '@context': 'https://schema.org',
  '@graph': [organization, website, locations.charonne, locations.voltaire, ...Object.keys(rooms).map((key) => rooms[key]), {
    '@type': 'WebPage', '@id': `${SITE_URL}/#webpage`, url: `${SITE_URL}/`, name: 'One Hour Escape Game Paris',
    isPartOf: { '@id': ENTITY_IDS.website }, about: { '@id': ENTITY_IDS.organization }, mainEntity: { '@id': ENTITY_IDS.organization }
  }]
})

export const buildRoomStructuredData = ({ roomKey, faq, lang = 'fr' }) => {
  const room = rooms[roomKey]
  const location = room.containedInPlace['@id'] === ENTITY_IDS.charonne ? locations.charonne : locations.voltaire
  const pageId = `${room.url}#webpage`

  return {
    '@context': 'https://schema.org',
    '@graph': [organization, website, location, room, {
      '@type': 'WebPage', '@id': pageId, url: room.url, name: room.name,
      isPartOf: { '@id': ENTITY_IDS.website }, about: { '@id': room['@id'] }, mainEntity: { '@id': room['@id'] },
      breadcrumb: { '@id': `${room.url}#breadcrumb` }, inLanguage: lang === 'en' ? 'en' : 'fr'
    }, {
      '@type': 'BreadcrumbList', '@id': `${room.url}#breadcrumb`,
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: lang === 'en' ? 'Home' : 'Accueil', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name: room.name, item: room.url }
      ]
    }, {
      '@type': 'FAQPage', '@id': `${room.url}#faq`, isPartOf: { '@id': pageId },
      mainEntity: faq.map((item) => ({
        '@type': 'Question', name: item[0], acceptedAnswer: { '@type': 'Answer', text: item[1] }
      }))
    }]
  }
}



// WEBPACK FOOTER //
// ./src/structuredData.js